import { TLC_CONSTANTS } from "../tlc-constants";
import { TLCLogger } from "../logger";
import { EMAIL_PATTERN, PHONE_NUMBER_PATTERN, ZIP_CODE_PATTERN } from "../../../javascript/tlc/Managers/ValidationManagerPlus";


/**
 *
 * @deprecated use tlc.validate
 */
export const ValidationManager = (function ($) {

	/* stock validators */
	var isValidPhoneNumber = function (phoneNumber) {
		return PHONE_NUMBER_PATTERN.test(phoneNumber);
	};
	var isValidZipCode = function (zipCode) {
		return ZIP_CODE_PATTERN.test(zipCode);
	};
	var isValidEmail = function (email) {
		return EMAIL_PATTERN.test(email);
	};

	var isAMatch = function (firstValue, validator) {
		var secondValue = getValue(validator.otherSelector);
		if (firstValue === secondValue) {
			return true;
		}
		return false;
	};

	var errorMessages = [];

	var getDefaultValidatorOptions = function (validator) {
		var baseValidatorOptions = {
			message: 'invalid',
			check: function (inString) {
				return true;
			}
		};
		switch (validator.type) {
			case TLC_CONSTANTS.ValidatorType.zipCode:
				return $.extend(true, {}, baseValidatorOptions, {
					message: 'invalid zip code',//TODO Constants
					check: isValidZipCode
				}, validator);
			case TLC_CONSTANTS.ValidatorType.phoneNumber:
				return $.extend(true, {}, baseValidatorOptions, {
					message: 'invalid phone number',//TODO Constants
					check: isValidPhoneNumber
				}, validator);
			case TLC_CONSTANTS.ValidatorType.email:
				return $.extend(true, {}, baseValidatorOptions, {
					message: 'invalid email address',//TODO Constants
					check: isValidEmail
				}, validator);
			case TLC_CONSTANTS.ValidatorType.match:
				return $.extend(true, {}, baseValidatorOptions, {
					message: 'values do not match',//TODO Constants
					check: isAMatch
				}, validator);
			default:
				return $.extend(true, {}, baseValidatorOptions, validator);
		}
	};
	var getFullValidationObject = function (validationObject) {
		var baseValidationObject = {
			delegateSelector: "body",
			fields: []
		};
		validationObject = $.extend(true, {}, baseValidationObject, validationObject);
		var fields = [];
		$.each(validationObject.fields, function (i, fieldOptions) {
			var tempField = $.extend(true, {}, baseFieldOptions, fieldOptions);
			var tempValidators = [];
			$.each(tempField.validators, function (j, validator) {
				tempValidators.push($.extend(true, {}, getDefaultValidatorOptions(validator), validator.options));
			});
			tempField.validators = tempValidators;
			fields.push(tempField);
		});
		validationObject.fields = fields;
		return validationObject;
	};

	var baseFieldOptions = {
		//selector: '',//should error if this is missing
		//defaultValue: '',//used if default has a value
		required: false,
		message: 'invalid',
		requiredMessage: 'field cannot be left blank',//TODO constants
		errorClass: TLC_CONSTANTS.CssClasses.error,
		successClass: TLC_CONSTANTS.CssClasses.success,
		requiredClass: TLC_CONSTANTS.CssClasses.required,
		validators: []//phone, zipCode, custom
	};
	var isSelect = function (selector) {
		return ($(selector).get(0).tagName == "SELECT");
	}
	var getValue = function (selector) {
		return isSelect(selector) ? $(selector).find('option:selected').val() : $(selector).val();
	};
	var checkValidators = function (field) {
		errorMessages = [];
		$.each(field.validators, function (i, validator) {
			if (validator.check(getValue(field.selector), validator) !== true) {
				field.message = validator.message;
				if (validator.otherSelector) {
					onError(validator.otherSelector);
				}
				errorMessages.push(validator.message);//TODO stop at first error?
			}
		});
		if (errorMessages.length > 0) {
			TLCLogger.log("errors");
			TLCLogger.log(errorMessages);//TODO display errorMessages
			return onError(field);
		}
		else {
			return onSuccess(field);
		}
	};
	var isNotEmptyOrDefaultValue = function (value, defaultValue) {
		var notEmptyPattern = /\S/;
		if (notEmptyPattern.test(value)) {//it's not empty
			if (value != defaultValue) {
				return true;//it's not empty or the default
			}
			else {
				return false;//it's the default
			}
		}
		else {
			return false;//it's empty
		}
	};
	var onError = function (field) {
		$(field.selector).addClass(field.errorClass).removeClass(field.successClass);
		return false;
	};
	var onSuccess = function (field) {
		$(field.selector).addClass(field.successClass).removeClass(field.errorClass);
		return true;
	};
	var checkField = function (field) {
		if (isNotEmptyOrDefaultValue(getValue(field.selector), field.defaultValue)) {
			return checkValidators(field);
		}
		else {
			return (field.required === true) ? onError(field) : onSuccess(field);
		}
	};
	var keyUpOrChangeHandler = function (field) {
		return function () {
			checkField(field);
		};
	};
	return {
		setValidation: function (validationObject) {
			validationObject = getFullValidationObject(validationObject);//extend default options
			$.each(validationObject.fields, function (i, field) {
				if (field.required === true) {
					$(field.selector).addClass(field.requiredClass).each(function (index, element) {
						if (element.id != null) {
							$("label[for='" + element.id + "']").addClass(TLC_CONSTANTS.CssClasses.required);
						}
					});
				}
				$(validationObject.delegateSelector)
					.on("keyup", field.selector, keyUpOrChangeHandler(field))
					.on("change", field.selector, keyUpOrChangeHandler(field))
					.on("blur", field.selector, keyUpOrChangeHandler(field));
				//.delegate(field.selector, "focus", function(event) {
				//	$(event.currentTarget).removeClass(field.errorClass);
				//});
			});
		},
		resetValidation: function (validationObject) {
			validationObject = getFullValidationObject(validationObject);
			$(validationObject.delegateSelector).off();
		},
		validateSubmit: function (validationObject, errorCallback) {
			validationObject = getFullValidationObject(validationObject);
			var errors = [];
			$.each(validationObject.fields, function (i, field) {
				var error = checkField(field);
				if (error !== true) {
					errors.push(field.message);
				}
			});
			if (errors.length > 0) {
				if (errorCallback) errorCallback(errors);
				return false;
			}
			else {
				return true;
			}
		},
		getEmailPattern: function () {
			return EMAIL_PATTERN;
		},
		getPhoneNumberPattern: function () {
			return PHONE_NUMBER_PATTERN;
		},
		getZipCodePattern: function () {
			return ZIP_CODE_PATTERN;
		}
	};
})(jQuery);
